import React from "react"
import clsx from "clsx"
import BedroomBuilderErrors from "../BedroomBuilderErrors"
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import AddButtonNew from "../../AddButton/AddButtonNew"

class BedroomBuilderBedroomTypes extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this)
    this.onAddBedroomType = this.onAddBedroomType.bind(this)
    this.onRemoveBedroomType = this.onRemoveBedroomType.bind(this)
    this.renderRemoveButton = this.renderRemoveButton.bind(this);
  }

  render() {
    var self = this;
    var tabClasses = clsx({
      'active': this.props.active_tab == 'bedroom_types',
      'tab-pane': true
    })

    var bedroom_type_bedrooms = this.props.bedroom_type_bedrooms.map((bedroom_type_bedroom, idx) => {
      return (
        <div className="panel-body container" key={idx}>
          <div className="row ht-row" key={idx}>
            <div className="col-md-2 name-wrapper">
              <div className="form-group">
                <label>{I18n.t('code')}</label>
                <div>{bedroom_type_bedroom.code}</div>
              </div>
            </div>
            <div className="col-md-2 name-wrapper">
              <div className="form-group">
                <label>{I18n.t('name')}</label>
                <div>{I18n.t(bedroom_type_bedroom.name)}</div>
              </div>
            </div>
            <div className="col-md-3" style={{ display: "flex" }}>
              <div className="form-group" style={{width: "100%"}}>
                <label>{I18n.t('quantity')}</label>
                <NumberSpinner
                  name={bedroom_type_bedroom.id + "|quantity"}
                  value={bedroom_type_bedroom.quantity || ''}
                  onChange={self.onChange}
                  className="form-control" />
              </div>
            </div>
            {self.renderRemoveButton(bedroom_type_bedroom.id)}
          </div>
        </div>
      )
    });
    
    return (
      <div className={tabClasses} id="bedroom_types">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6" >
                  <h3 className="panel-title">
                    {I18n.t('bedroom_types')} <span className="ss-help help" title={I18n.t('seasonal_prices_helper_text')}></span>
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <AddButtonNew
                    key={this.props.bedroom_id}
                    disabled={this.props.disabled}
                    new_button={false}
                    model="BedroomType"
                    text={I18n.t('add')}
                    ids={this.props.bedroom_type_bedrooms ? this.props.bedroom_type_bedrooms.map((bedroom_type) => { return bedroom_type.id; }) : null}
                    onAdd={self.onAddBedroomType}
                    view_type="bedroom_type"
                    buttonClasses="btn btn-secondary"
                    generalPosition="left"
                  />
                </div>
              </div>
              {bedroom_type_bedrooms.length ? bedroom_type_bedrooms : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
  * Change handlers
  */

  onAddBedroomType(bedroom_type) {
    // console.log("in onAddBedroomal");
    var bedroom_type_bedrooms = this.props.bedroom_type_bedrooms.slice(0);
    var bedroom_type_bedroom = {
      id: bedroom_type.id,
      code: bedroom_type.code,
      name: bedroom_type.name,
    };

    bedroom_type_bedrooms.unshift(bedroom_type_bedroom);
    this.props.onChangeBedroomTypes(bedroom_type_bedrooms);
  }

  onRemoveBedroomType(bedroom_type_bedroom_id) {
    var bedroom_type_bedrooms = this.props.bedroom_type_bedrooms.slice(0);
    var idx = this.getBedroomTypeIndexById(bedroom_type_bedroom_id);

    if (idx >= 0) {
      bedroom_type_bedrooms.splice(idx, 1);
      this.props.onChangeBedroomTypes(bedroom_type_bedrooms);
    }
  }

  getBedroomTypeIndexById(id) {
    for (var i = 0, ilen = this.props.bedroom_type_bedrooms.length; i < ilen; i++) {
      if (this.props.bedroom_type_bedrooms[i].id == id) {
        return i;
      }
    }
  }

  onChange(event) {
    if (event && event.target) {

      var bedroom_type_bedroom_id = event.target.name.split('|')[0]
      var name = event.target.name.split('|')[1]

      if (this.props.bedroom_type_bedrooms && this.props.bedroom_type_bedrooms.length) {
        
        for (var i = 0, ilen = this.props.bedroom_type_bedrooms.length; i < ilen; i++) {
          if (this.props.bedroom_type_bedrooms[i].id == bedroom_type_bedroom_id) {
            this.props.bedroom_type_bedrooms[i][name] = event.target.value
           
            break
          }
        }
      }

      this.props.onChangeBedroomTypes(this.props.bedroom_type_bedrooms)
    }
  }

  renderRemoveButton(id) {
    if (typeof this.onRemoveBedroomType == 'function') {
      return (
        <div className="col-md-1 col-remove" >
          <button type="button" name={id} className="btn btn-secondary" onClick={(e) => this.onRemoveBedroomType(e)}>{I18n.t('remove')}</button>
        </div>
      );
    }

    return null;
  }

  /**
  * Helper functions
  */

  // returnErrors(bedroom_type_id) {
  //   var errors = BedroomBuilderErrors.roomTypesErrors(this.props.errors)
  //   var returnErrors = null
  //   for (var i = 0; i < errors.length; i++) {
  //     if (Object.keys(errors[i])[0] === room_type_price_id) {
  //       returnErrors = Object.values(errors[i])[0]
  //     }
  //   }
  //   return returnErrors
  // }

};

export default BedroomBuilderBedroomTypes
